import { render, staticRenderFns } from "./MostrarComprobanteTraspaso.vue?vue&type=template&id=3d19e18c&scoped=true"
import script from "./MostrarComprobanteTraspaso.vue?vue&type=script&lang=js"
export * from "./MostrarComprobanteTraspaso.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d19e18c",
  null
  
)

export default component.exports